import React from 'react'
import './block-text-half.sass'

const BlockTextHalf = ({ data }) => {
  const md = data.content[0];
  const md2 = data.content[1];

  return (
    <section className={`
      BlockTextHalf
      container-fluid
      ${data.classes ? data.classes : ''}
    `}>
      <div className="row">
        <div className="col-md-6">
          <div
              className="BlockTextHalf__content"
              dangerouslySetInnerHTML={{ __html: md }} />
        </div>
        <div className="col-md-6">
          <div className="BlockTextHalf__content-wrap">
            <div
              className="BlockTextHalf__content"
              dangerouslySetInnerHTML={{ __html: md2 }} />
          </div>
        </div>
      </div>
    </section>
  )
}

export default BlockTextHalf
